export enum CastDeviceVersion {
  GEN1 = 'GEN1',
  GEN2 = 'GEN2',
  GEN3 = 'GEN3',
  ULTRA_4k = 'ULTRA_4K',
  GOOGLE_TV = 'GOOGLE_TV',
  GOOGLE_TV_4k = 'GOOGLE_TV_4K',
  NEST_HUB = 'NEST_HUB',
  NEST_HUB_MAX = 'NEST_HUB_MAX',
  UNKNOWN = 'UNKNOWN',
  DETECTION_FAILED = 'DETECTION_FAILED',
}

export type CastDeviceVersionType =
  | 'GEN1'
  | 'GEN2'
  | 'GEN3'
  | 'ULTRA_4K'
  | 'GOOGLE_TV'
  | 'GOOGLE_TV_4K'
  | 'NEST_HUB'
  | 'NEST_HUB_MAX'
  | 'UNKNOWN'
  | 'DETECTION_FAILED';
